export const Kind = {
  /** 原稿 */
  MANUSCRIPT: "manuscript",
  /** プロット */
  PLOT: "plot",
  /** 登場人物 */
  CHARACTER: "character",
  /** 世界観 */
  WORLDVIEW: "worldView",
  /** 相関関係グループ */
  CORRELATION_GROUP: "correlationGroup",
  /** メモタグ */
  MEMO_TAG: "memoTag",
  /** 資料種別 */
  MATERIAL_ATTRIBUTE: "materialAttribute",
  /** 資料入力テンプレート */
  MATERIAL_INPUT_TEMPLATE: "materialInputTemplate",
  /** 作品グループ */
  NOVEL_GROUP: "novelGroup",
  /** 固有名詞 */
  PROPER_NOUN: "properNoun",
  /**
   * 固有名詞モーダルのタブ並び順。
   * 命名は「固有名詞カテゴリ」だが、実態は登場人物/世界観/資料/固有名詞カテゴリ/カスタムを含む
   * 全タブ（未分類を除く）の並び順。order には各要素の生ID
   * （character / worldview / 資料属性ID / properNounCategory値 [characterName 等] /
   * カスタムカテゴリID）を格納する。他機能（資料属性の並び順など）と同じ生ID形式で統一しており、
   * tab- のようなUI内部プレフィックスは付けない。
   * （キー名はバックエンド共有のため改名せず、用途をコメントで補足）
   */
  PROPER_NOUN_CATEGORY: "properNounCategory",
} as const;
// eslint-disable-next-line no-redeclare
export type Kind = typeof Kind[keyof typeof Kind];

/**
 * 並び順
 */
export interface SortOrder {
  novelId?: string;
  kind: Kind;
  order: string[];
  createdAt: number;
  updatedAt: number;
}

export interface UpdateOrder {
  novelId: string;
  kind?: Kind;
  order: string[];
}
